module.exports = __webpack_public_path__ + "media/images/dottedloader-fa05d6ed.gif";